import { useRef } from "react";

import {
  useAutoSaveSession,
  useHydrateSession,
  useInitializeSessionOnMount,
  useNavigationSessionNameGuard,
  SaveCompletionTracker,
} from "./sessions";

const usePlaygroundSession = () => {
  const saveCompletionTrackerRef = useRef<SaveCompletionTracker | null>(null);

  const hydrationState = useHydrateSession();
  useInitializeSessionOnMount(hydrationState);
  useAutoSaveSession(hydrationState, saveCompletionTrackerRef);
  useNavigationSessionNameGuard(saveCompletionTrackerRef);
};

export default usePlaygroundSession;
